module.exports = __webpack_public_path__ + "static/media/user-icon.e1ebee69.png";